/* !
 * jQuery artists v1.0.0
 * Copyright 2018, Connecty Inc.
 */
(function($, IBANEZ){
	const urlRegion = IBANEZ.va.pathname.split('/')[1];
	const map = IBANEZ.va.pathname.split('/')[3];
	const thisCat = IBANEZ.va.pathname.split('/')[4];

	const getJSONsignatureModel = (_cat, _key) => {
		return $.getJSON(`/${urlRegion}/ajax/category_model/${_cat}/${_key}.json`);
	};

	// ＜CATEGORY＞ アーティストブロック内のモデル名カテゴリチェック
	const checkModelCategory = () => {
		$('.rt_bn_artist').each((idx, ele) => {
			$(ele).find('.cf_a_signature_models').each((idx2, ele2) => {
				getJSONsignatureModel(thisCat, $(ele2).find('.rt_cf_a_signature_models_cf_pm_name').attr('data-key')).then((data) => {
					if(!data.rt_bn_product_model.length) {
						$(ele2).remove();
					}
				});
			});
		});
	};
	// ＜CATEGORY＞ findLINK ※国コードを取得し初期値にする
	const setFindLink = () => {
		const $findLink = $('.js-findLink');
		geoip2.country((geoipResponse) => {
			const clientCountry = geoipResponse.country.iso_code;
			$findLink.attr('href', `/${urlRegion}/artists/search/${thisCat}/list/?p_country_id=${clientCountry}`);
		}, () => {
			console.log('Error');
			$findLink.attr('href', `/${urlRegion}/artists/search/${thisCat}/list/`);
		});
	};
	if(map === 'category') {
		if($('.artists-signature').find('.rt_bn_artist').length) {
			checkModelCategory();
		} else {
			$('.artists-signature').remove();
		}
		setFindLink();
	}

	// ＜アーティスト詳細＞
	if(map === 'detail') {
		if(!$('.artists-detail-official').find('.artists-detail-links-block').length) {
			$('.artists-detail-official').remove();
		}
	}

	// ＜アーティスト検索＞
	let thisParam = [];
	if(location.search) {
		thisParam = location.search.replace(/\?/, '').split('&');
	}
	let sigunatureFlg = '';
	let labelsHTML = '';

	const setParam = () => {
		let newParam = '?';
		for(let i=0; i<thisParam.length; i++) {
			if(thisParam[i].indexOf('result_skip') === -1) {
				newParam += `${thisParam[i]}&`;
			}
		}
		return newParam.slice(0, -1);
	};
	const changeParam = (_name, _val) => {
		let setFlg = false;
		for(let i = 0; i < thisParam.length; i++) {
			if(thisParam[i].indexOf(_name) !== -1) {
				thisParam[i] = `${_name}=${_val}`;
				setFlg = true;
			}
		}
		if(!setFlg) {
			thisParam.push(`${_name}=${_val}`);
		}
	};
	const checkSignatureModel = () => {
		if($('.js-signatureModel').prop('checked')) {
			sigunatureFlg = 'signature.html';
		} else {
			sigunatureFlg = '';
		}
	};
	const setTagLabel = () => {
		if(thisParam.length) {
			for(let i = 0; i < thisParam.length; i++) {
				let name = thisParam[i].split('=')[0];
				let val = thisParam[i].split('=')[1];
				let label;
				if(thisParam[i].indexOf('p_country_id') !== -1) {
					if(val) {
						label = $('.js-select-country').find(`option[value=${val}]`).text();
					}
				} else if(thisParam[i].indexOf('p_artist_name') !== -1 || thisParam[i].indexOf('p_initial') !== -1) {
					label = val;
				}
				if(label && val) {
					labelsHTML +=
					`<li class="artists-categorList-result-labels-item" data-name="${name}" data-value="${val}">
					<span class="artists-categorList-result-labels-item-text">${label}<i class="icon icon-cloase js-deleteLabel" tabindex="0"></i>
					</span></li>`;
				}
			}
		}
		if(sigunatureFlg) {
			labelsHTML +=
			`<li class="artists-categorList-result-labels-item" data-name="sigunature">
			<span class="artists-categorList-result-labels-item-text">SIGNATURE MODELS<i class="icon icon-cloase js-deleteLabel"></i>
			</span></li>`;
		}
		if(labelsHTML) {
			$('.js-search-labels').append(labelsHTML);
		} else {
			$('.artists-categorList-result-head').remove();
		}

		// タグラベル削除ボタン押下時
		const deleteLabelClick = (e) => {
			let name = $(e.currentTarget).parents('.artists-categorList-result-labels-item').attr('data-name');
			let val = $(e.currentTarget).parents('.artists-categorList-result-labels-item').attr('data-value');
			let newParam = thisParam.filter(n => n !== `${name}=${val}`);
			thisParam = newParam;

			if (name === 'sigunature') {
				location.href = `/${urlRegion}/artists/search/${thisCat}/list/${setParam()}`;
			} else {
				checkSignatureModel();
				location.href = `/${urlRegion}/artists/search/${thisCat}/list/${sigunatureFlg}${setParam()}`;
			}
		};
		$('.js-deleteLabel').on('click', (e) => { deleteLabelClick(e); });
		$('.js-deleteLabel').keydown(function (e) {
			if (e.key === 'Enter') { deleteLabelClick(e); }
		});
	};
	const setSearchForm = () => {
		// SELECT CATEGORY
		const $selectCat = $('.js-select-category');
		$selectCat.val(thisCat);
		$selectCat.change((e) => {
			location.href = `/${urlRegion}/artists/search/${$(e.currentTarget).val()}/list/`;
		});
		// ARTIST NAME
		$('.js-artist-name').change((e) => {
			changeParam('p_artist_name', $(e.currentTarget).val());
			checkSignatureModel();
			location.href = `/${urlRegion}/artists/search/${thisCat}/list/${sigunatureFlg}${setParam()}`;
		});
		// COUNTRY
		$('.js-select-country').change((e) => {
			changeParam('p_country_id', $(e.currentTarget).val());
			checkSignatureModel();
			location.href = `/${urlRegion}/artists/search/${thisCat}/list/${sigunatureFlg}${setParam()}`;
		});
		// NAME(A-Z)
		$('.js-select-initial').change((e) => {
			changeParam('p_initial', $(e.currentTarget).val());
			checkSignatureModel();
			location.href = `/${urlRegion}/artists/search/${thisCat}/list/${sigunatureFlg}${setParam()}`;
		});
		// SIGNATURE MODELS
		$('.js-signatureModel').change(() => {
			checkSignatureModel();
			location.href = `/${urlRegion}/artists/search/${thisCat}/list/${sigunatureFlg}${setParam()}`;
		});
		// ALL CLEAR
		$('.js-allClear').on('click', () => {
			location.href = `/${urlRegion}/artists/search/${thisCat}/list/`;
		});
		$('.js-allClear').keydown(function (e) {
			if (e.key === 'Enter') { location.href = `/${urlRegion}/artists/search/${thisCat}/list/`; }
		});
	};

	if(map === 'search') {
		if(IBANEZ.va.pathname.split('/')[6] === 'signature.html') {
			$('.js-signatureModel').prop('checked', 'checked');
			sigunatureFlg = 'signature.html';
		}

		setTagLabel();
		setSearchForm();
	}

})(window.jQuery, window.IBANEZ);
